import React from 'react'
import Notes from './Notes'
const InternalNotes = (disabled) => {
  return (
    <div>
          <Notes
                    //   disabled={disabled}
                      name="description"
                      style={{
                        width: "900px",
                        border: "1px solid #CBCBCB",
                        margin: "10px 15px 15px",
                        padding: "10px",
                        borderRadius: "15px",
                        color: "#535559",
                        height: "160px",
                        backgroundColor: "#f5f5f5",
                      }}
                    />
    </div>
  )
}

export default InternalNotes
